import { Box, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import CheckBoxTableRow from "./CheckBoxTableRow";
import {
  WhatsappConfigurationType,
  WhatsappNotificationConfiguration,
} from "../types";
import { useState, useEffect } from "react";

type SendByMethods =
  | "reportMonthlyConfiguration"
  | "reportDailyConfiguration"
  | "reportPartialConfiguration"
  | "alarmsBlandConfiguration"
  | "alarmsMediumConfiguration"
  | "alarmsSevereConfiguration";

export default function UserWhatsappConfigurationToggle(props: {
  whatsappConfigurationType: WhatsappConfigurationType;
  whatsappConfigurationName: SendByMethods;
  whatsappConfiguration: WhatsappNotificationConfiguration;
  setWhatsappConfiguration: React.Dispatch<
    React.SetStateAction<WhatsappNotificationConfiguration | undefined>
  >;
  title: string;
  disabled: boolean;
}) {
  const {
    whatsappConfigurationType,
    title,
    disabled,
    setWhatsappConfiguration,
    whatsappConfiguration,
    whatsappConfigurationName,
  } = props;
  const [whatsappSwitch, setWhatsappSwitch] = useState<boolean>(
    whatsappConfigurationType.enabled
  );
  function updateConfiguration() {
    setWhatsappConfiguration({
      ...whatsappConfiguration,
      [whatsappConfigurationName]: {
        name: whatsappConfigurationType.name,
        enabled: whatsappSwitch,
      },
    });
  }

  useEffect(() => {
    updateConfiguration();
  }, [whatsappSwitch]);

  return (
    <Tooltip title={disabled ? "Notificações de whatsapp desabilitadas" : ""}>
      <TableRow>
        <TableRow sx={{ display: "flex", width: "100%" }}>
          <TableCell
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            align="left"
          >
            <Typography
              sx={{
                color: disabled ? "rgba(217, 217, 217, 0.5)" : "#FFF",
              }}
            >
              {title}
            </Typography>
            <Box
              sx={{ display: "flex", flexDirection: "row", columnGap: "32px" }}
            >
              <CheckBoxTableRow
                disabled={disabled}
                active={whatsappSwitch}
                onChange={(_, checked) => {
                  setWhatsappSwitch(checked);
                }}
              />
            </Box>
          </TableCell>
        </TableRow>
      </TableRow>
    </Tooltip>
  );
}
